import { I18n } from './i18n';

/**
 * @param {object|null|undefined} user Redux user / profile
 * @returns {string|null} Translated role label, or null if unknown
 */
export function getTranslatedUserRoleLabel(user) {
  if (!user) return null;

  const { mvpUserType, type } = user;

  if (mvpUserType === 'explorer') return I18n.t('account_type_selection_senior');
  if (mvpUserType === 'guide') return I18n.t('account_type_selection_senior_buddy');
  if (mvpUserType === 'both') return I18n.t('account_type_selection_senior');

  if (type === 'senior' || type === 'explorer') return I18n.t('account_type_selection_senior');
  if (type === 'seniorBuddy' || type === 'student' || type === 'guide') {
    return I18n.t('account_type_selection_senior_buddy');
  }
  if (type === 'both') return I18n.t('account_type_selection_senior');

  return null;
}
